import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import type { ListenerInterface } from '@kiplin/web-common/event';
import { AppDependencyTypes } from '@shared/common/app/app.dependency-types';
import { AuthenticationRequiredNavigationListener } from '@shared/feature/login/application/listener/authentication-required-navigation.listener';

export const routerContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  options
    .bind<ListenerInterface>(AppDependencyTypes.AuthenticationRequiredNavigationListener)
    .to(AuthenticationRequiredNavigationListener)
    .inSingletonScope();
});
